import React from "react";

const ActivityCardContainer = props => {
  return (
    <div className="offset-sm-1 t-col-sm-10 t-col-md-4 t-col-lg-3 t-col-xl-3">{props.children}</div>
  );
};

export default ActivityCardContainer;
